import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["highlight", "use"];
import PrimaryMessageContent from '../primary-message/components/PrimaryMessageContent';
import HeaderWrapper from '../slotted-message/HeaderWrapper';
import PrimaryMessageContentSection from '../primary-message/components/PrimaryMessageContentSection';
import SenderAvatar from '../avatar/SenderAvatar';
import PrimaryMessage from '../primary-message/components/PrimaryMessage';
import PrimaryMessageFooter from '../primary-message/components/PrimaryMessageFooter';
import { ColorIndicator } from '../common-message/ColorIndicator';
import ContentText from '../primary-message/ContentText';
import { Text } from 'foundations-components/components/Text';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { AGENT } from 'conversations-message-history/constants/messageUses';

// util to help see props directly
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SlottedMessage = props => {
  const {
    container,
    avatar,
    title,
    byline,
    body,
    indicator,
    detail,
    channel,
    detailsPopover,
    timestamp,
    actions,
    footerTitle,
    footerBody,
    annotation
  } = props;
  const IndicatorComponent = indicator === null || indicator === void 0 ? void 0 : indicator.Component;
  const AvatarComponent = (avatar === null || avatar === void 0 ? void 0 : avatar.Component) || SenderAvatar;
  const BylineComponent = byline === null || byline === void 0 ? void 0 : byline.Component;
  const BodyComponent = (body === null || body === void 0 ? void 0 : body.Component) || ContentText;
  const FooterBodyComponent = footerBody === null || footerBody === void 0 ? void 0 : footerBody.Component;
  const AnnotationComponent = annotation === null || annotation === void 0 ? void 0 : annotation.Component;
  const FooterTitleComponent = footerTitle === null || footerTitle === void 0 ? void 0 : footerTitle.Component;
  const _ref = (container === null || container === void 0 ? void 0 : container.componentProps) || {},
    {
      highlight,
      use
    } = _ref,
    containerProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsxs(PrimaryMessage, Object.assign({}, containerProps, {
    children: [/*#__PURE__*/_jsxs(PrimaryMessageContent, {
      use: use || AGENT,
      highlight: highlight,
      children: [indicator !== null && indicator !== void 0 && indicator.renderCustom ? indicator.renderCustom({
        Component: ColorIndicator
      }) : IndicatorComponent ? /*#__PURE__*/_jsx(IndicatorComponent, Object.assign({}, indicator === null || indicator === void 0 ? void 0 : indicator.componentProps)) : (indicator === null || indicator === void 0 ? void 0 : indicator.componentProps) && /*#__PURE__*/_jsx(ColorIndicator, Object.assign({}, indicator.componentProps)), /*#__PURE__*/_jsxs(Flex, {
        flexDirection: "row",
        paddingBlock: "200",
        children: [/*#__PURE__*/_jsx(Flex, {
          flexDirection: "row",
          alignItems: "start",
          marginInlineEnd: "200",
          children: avatar !== null && avatar !== void 0 && avatar.isLoading ? /*#__PURE__*/_jsx(SenderAvatar, {
            isLoading: true,
            size: 'sm'
          }) : avatar !== null && avatar !== void 0 && avatar.renderCustom ? avatar.renderCustom({
            Component: SenderAvatar
          }) // could expose stuff here to consumers, like bot senders, etc for building an avatar
          : AvatarComponent && /*#__PURE__*/_jsx(AvatarComponent, Object.assign({
            size: 'sm'
          }, avatar === null || avatar === void 0 ? void 0 : avatar.componentProps))
        }), /*#__PURE__*/_jsxs(Flex, {
          display: "inline-flex",
          flexDirection: "column",
          alignItems: "center",
          flex: "1",
          overflow: "auto",
          children: [/*#__PURE__*/_jsx(HeaderWrapper, {
            title: title,
            detail: detail,
            channel: channel,
            detailsPopover: detailsPopover,
            timestamp: timestamp,
            actions: actions
          }), byline !== null && byline !== void 0 && byline.renderCustom ? /*#__PURE__*/_jsx(View, {
            inlineSize: "100%",
            children: /*#__PURE__*/_jsx(Text, {
              marginBlockStart: "100",
              paddingBlockEnd: "200",
              paddingInlineEnd: "200",
              typography: "detail-100",
              color: "text-core-subtle",
              children: byline.renderCustom()
            })
          }) : BylineComponent && /*#__PURE__*/_jsx(View, {
            inlineSize: "100%",
            children: /*#__PURE__*/_jsx(Text, {
              marginBlockStart: "100",
              paddingBlockEnd: "200",
              paddingInlineEnd: "200",
              typography: "detail-100",
              color: "text-core-subtle",
              children: /*#__PURE__*/_jsx(BylineComponent, Object.assign({}, byline === null || byline === void 0 ? void 0 : byline.componentProps))
            })
          }), /*#__PURE__*/_jsxs(PrimaryMessageContentSection, {
            children: [body !== null && body !== void 0 && body.renderCustom ? body.renderCustom({
              Component: ContentText
            }) : ((body === null || body === void 0 ? void 0 : body.Component) || (body === null || body === void 0 ? void 0 : body.componentProps)) && /*#__PURE__*/_jsx(BodyComponent, Object.assign({}, body === null || body === void 0 ? void 0 : body.componentProps)), footerTitle !== null && footerTitle !== void 0 && footerTitle.renderCustom ? /*#__PURE__*/_jsx(Text, {
              as: "small",
              typography: "detail-200",
              children: footerTitle.renderCustom()
            }) : FooterTitleComponent && /*#__PURE__*/_jsx(Text, {
              as: "small",
              typography: "detail-200",
              children: /*#__PURE__*/_jsx(FooterTitleComponent, Object.assign({}, footerTitle === null || footerTitle === void 0 ? void 0 : footerTitle.componentProps))
            }), footerBody !== null && footerBody !== void 0 && footerBody.renderCustom ? /*#__PURE__*/_jsx(Text, {
              as: "small",
              typography: "detail-200",
              children: footerBody.renderCustom()
            }) : FooterBodyComponent && /*#__PURE__*/_jsx(Text, {
              as: "small",
              typography: "detail-200",
              children: /*#__PURE__*/_jsx(FooterBodyComponent, Object.assign({}, footerBody === null || footerBody === void 0 ? void 0 : footerBody.componentProps))
            })]
          })]
        })]
      })]
    }), annotation !== null && annotation !== void 0 && annotation.renderCustom ? /*#__PURE__*/_jsx(PrimaryMessageFooter, {
      children: /*#__PURE__*/_jsx(Text, {
        color: "text-core-subtle",
        typography: "detail-100",
        children: annotation.renderCustom()
      })
    }) : AnnotationComponent && /*#__PURE__*/_jsx(PrimaryMessageFooter, {
      children: /*#__PURE__*/_jsx(Text, {
        color: "text-core-subtle",
        typography: "detail-100",
        children: /*#__PURE__*/_jsx(AnnotationComponent, Object.assign({}, annotation === null || annotation === void 0 ? void 0 : annotation.componentProps))
      })
    })]
  }));
};
SlottedMessage.displayName = 'SlottedMessage';
export default SlottedMessage;